<template>
  <div class="group-edit-units-modal">
    <q-form @submit="onSubmit" class="modal-form">
      <div class="modal-content">
        <div class="modal-header">
          <div class="change-all-section">
            <CustomCheckbox :value="changeAll" @change="onChangeAll" label="Изменить все" size="xs" />
          </div>
        </div>

        <div class="units-section">
          <div class="unit-row">
            <div class="unit-group">
              <CustomSelect :options="unitOptions" label="Единица измерения продажи*" option-label-key="unit_name"
                option-value-key="unit_id" :value="formData.sale_unit_id"
                @change="(value) => onChange('sale_unit_id', value)" placeholder="Не выбрано" required />
            </div>
            <div class="arrow-icon">
              <SvgIcon name="shape" color="#FFFFFF" class="q-icon" />
            </div>
            <div class="unit-group">
              <CustomInput label="Кол-во единиц продаж в одной ед. отпуска*" placeholder="Введите..."
                :value="formData.sale_to_release_ratio"
                @change_input="(value) => onChange('sale_to_release_ratio', value)" required :showClearIcon="false"
                :disable="!formData.sale_unit_id && !formData.sale_unit_enabled && !changeAll" />
            </div>
            <div class="checkbox-group">
              <CustomCheckbox :value="formData.sale_unit_enabled"
                @change="(value) => onChange('sale_unit_enabled', value)" size="xs" />
            </div>
          </div>

          <div class="unit-row">
            <div class="unit-group">
              <CustomSelect :options="unitOptions" label="Единица измерения расхода*" option-label-key="unit_name"
                option-value-key="unit_id" :value="formData.consumption_unit_id"
                @change="(value) => onChange('consumption_unit_id', value)" placeholder="Не выбрано" required />
            </div>
            <div class="arrow-icon">
              <SvgIcon name="shape" color="#FFFFFF" class="q-icon" />
            </div>
            <div class="unit-group">
              <CustomInput label="Кол-во единиц расхода в ед. отпуска*" placeholder="Введите..."
                :value="formData.consumption_to_release_ratio"
                @change_input="(value) => onChange('consumption_to_release_ratio', value)" required
                :showClearIcon="false"
                :disable="!formData.consumption_unit_id && !formData.consumption_unit_enabled && !changeAll" />
            </div>
            <div class="checkbox-group">
              <CustomCheckbox :value="formData.consumption_unit_enabled"
                @change="(value) => onChange('consumption_unit_enabled', value)" size="xs" />
            </div>
          </div>

          <div class="unit-row">
            <div class="unit-group">
              <CustomSelect :options="unitOptions" label="Единица отпуска из магазина*" option-label-key="unit_name"
                option-value-key="unit_id" :value="formData.release_unit_id"
                @change="(value) => onChange('release_unit_id', value)" placeholder="Не выбрано" required />
            </div>
            <div class="arrow-icon">
              <SvgIcon name="shape" color="#FFFFFF" class="q-icon" />
            </div>
            <div class="unit-group">
              <CustomInput label="Кол-во минимальной единицы в одной ед. отпуска*" placeholder="Введите..."
                :value="formData.min_to_release_ratio"
                @change_input="(value) => onChange('min_to_release_ratio', value)" required :showClearIcon="false"
                :disable="!formData.release_unit_id && !formData.release_unit_enabled && !changeAll" />
            </div>
            <div class="checkbox-group">
              <CustomCheckbox :value="formData.release_unit_enabled"
                @change="(value) => onChange('release_unit_enabled', value)" size="xs" />
            </div>
          </div>

          <div class="unit-row">
            <div class="unit-group">
              <CustomSelect :options="unitOptions" label="Минимальная единица*" option-label-key="unit_name"
                option-value-key="unit_id" :value="formData.min_unit_id" @change="(value) => onChange('min_unit_id', value)"
                placeholder="Не выбрано" required />
            </div>
            <div class="arrow-icon">
              <SvgIcon name="shape" color="#FFFFFF" class="q-icon" />
            </div>
            <div class="unit-group">
              <CustomInput label="Коэффициент минимальной единицы в одной упаковке*" placeholder="Введите..."
                :value="formData.min_unit_coefficient"
                @change_input="(value) => onChange('min_unit_coefficient', value)" required :showClearIcon="false"
                :disable="!formData.min_unit_id && !formData.min_unit_enabled && !changeAll" />
            </div>
            <div class="checkbox-group">
              <CustomCheckbox :value="formData.min_unit_enabled"
                @change="(value) => onChange('min_unit_enabled', value)" size="xs" />
            </div>
          </div>
        </div>
      </div>

      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput/index.vue";
import CustomSelect from "@/components/form/CustomSelect/index.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox/index.vue";
import CustomButton from "@/components/common/CustomButton";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import SvgIcon from "@/components/common/SvgIcon";
import { getUnitsList } from "@/views/Materials/services";

export default {
  name: "GroupEditUnits",
  components: {
    CustomInput,
    CustomSelect,
    CustomCheckbox,
    CustomButton,
    CustomModalFooter,
    SvgIcon
  },
  props: {
    title: {
      type: String,
      default: "Групповое изменение единиц измерения"
    },
    selectedMaterials: {
      type: Array,
      default: () => []
    },
    onSubmit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      changeAll: false,
      formData: {
        sale_unit_id: '',
        sale_to_release_ratio: '',
        sale_unit_enabled: false,
        consumption_unit_id: '',
        consumption_to_release_ratio: '',
        consumption_unit_enabled: false,
        release_unit_id: '',
        min_to_release_ratio: '',
        release_unit_enabled: false,
        min_unit_id: '',
        min_unit_coefficient: '',
        min_unit_enabled: false,
      },
      unitOptions: []
    };
  },
  methods: {
    async getUnitsList() {
      const res = await getUnitsList();
      if (!res) return;
      this.unitOptions = res;
    },
    onChange(key, value) {
      this.formData[key] = value;

      if (key === 'sale_unit_id') {
        this.formData.sale_to_release_ratio = '';
      } else if (key === 'consumption_unit_id') {
        this.formData.consumption_to_release_ratio = '';
      } else if (key === 'release_unit_id') {
        this.formData.min_to_release_ratio = '';
      } else if (key === 'min_unit_id') {
        this.formData.min_unit_coefficient = '';
      }

      if (key === 'sale_unit_enabled' && !value && !this.formData.sale_unit_id) {
        this.formData.sale_to_release_ratio = '';
      } else if (key === 'consumption_unit_enabled' && !value && !this.formData.consumption_unit_id) {
        this.formData.consumption_to_release_ratio = '';
      } else if (key === 'release_unit_enabled' && !value && !this.formData.release_unit_id) {
        this.formData.min_to_release_ratio = '';
      } else if (key === 'min_unit_enabled' && !value && !this.formData.min_unit_id) {
        this.formData.min_unit_coefficient = '';
      }
    },
    onChangeAll(value) {
      this.changeAll = value;
      if (value) {
        this.formData.sale_unit_enabled = true;
        this.formData.consumption_unit_enabled = true;
        this.formData.release_unit_enabled = true;
        this.formData.min_unit_enabled = true;
      } else {
        this.formData.sale_unit_enabled = false;
        this.formData.consumption_unit_enabled = false;
        this.formData.release_unit_enabled = false;
        this.formData.min_unit_enabled = false;

        if (!this.formData.sale_unit_id) {
          this.formData.sale_to_release_ratio = '';
        }
        if (!this.formData.consumption_unit_id) {
          this.formData.consumption_to_release_ratio = '';
        }
        if (!this.formData.release_unit_id) {
          this.formData.min_to_release_ratio = '';
        }
        if (!this.formData.min_unit_id) {
          this.formData.min_unit_coefficient = '';
        }
      }
    },
    onSubmit() {
      const payload = {
        selectedMaterials: this.selectedMaterials,
        changes: this.formData,
        changeAll: this.changeAll
      };

      this.onSubmit(payload);
    },
    onCancel() {
      this.$emit('close');
    }
  },
  async mounted() {
    await this.getUnitsList();
  },
};
</script>

<style scoped lang="scss">
.group-edit-units-modal {
  width: 687px;
  max-width: 90vw;
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.change-all-section {
  display: flex;
  align-items: center;
  gap: 8px;

  :deep(.q-checkbox__label) {
    color: #373D48;
    font-size: 14px;
  }
}

.units-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.unit-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}

.unit-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.arrow-icon {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9CA3AF;
  border-radius: 50%;
  width: 24px;
  height: 24px;

  .q-icon {
    width: 24px;
    height: 24px;
  }
}

.checkbox-group {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
}
</style>
